import * as React from 'react';
import { useInView } from 'react-intersection-observer';
import { MediaQuery } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { ActionButtons } from '../components/ActionButtons.js';
import '@swc/helpers';
import '@grandvisionhq/utils';
import '../../../context/Cart/context.js';
import '@grandvisionhq/graphql';
import '@grandvisionhq/svc-tealium/events';
import '../../../models/add-to-cart/add-to-cart.js';
import '../../../models/cart/cart.js';
import '../../../models/subscription/subscription-details.js';
import '../../../models/checkoutState/checkoutState.js';
import '../../../utils/cart-count-var.js';
import '../../../utils/cart-id-var.js';
import '@grandvisionhq/commercetools';
import '../../../utils/get-unrecoverable-validation-errors.js';
import '../../../models/line-item/prescription-glasses.js';
import '../../../utils/get-failure-error-codes.js';
import '../../../utils/get-validation-errors-by-line-item.js';
import '@grandvisionhq/lib-visuals';
import '../../../operations/fragments/cart-details.js';
import '../../../operations/fragments/cart-validation-errors.js';
import '../../../operations/fragments/recover-inactive-cart-failure.js';
import '../../../operations/fragments/recover-inactive-cart-result.js';
import '../../../operations/mutations/add-cart-line-items.js';
import '../../../operations/mutations/add-cart-voucher-codes.js';
import '../../../operations/mutations/create-cart.js';
import '../../../operations/mutations/create-cart-from-instant-checkout-link.js';
import '../../../operations/mutations/create-cart-from-order.js';
import '../../../operations/mutations/duplicate-cart-line-items.js';
import '../../../operations/mutations/remove-cart-voucher-codes.js';
import '../../../operations/mutations/remove-cart-line-items.js';
import '../../../operations/mutations/update-cart-line-items.js';
import '../../../operations/mutations/replace-line-item-contact-lenses-bundle-benelux.js';
import '../../../operations/mutations/recover-inactive-cart.js';
import '../../../operations/queries/get-cart.js';
import '../../../operations/queries/get-total-line-items.js';
import '../../../operations/queries/get-cart-estimated-delivery.js';
import '../../../context/CartSettings/context.js';
import 'classnames';
import '../../../slots/context.js';
import '../../../slots/header-slot/context.js';
import '../../../slots/sidebar-slot/context.js';
import '@grandvisionhq/elements';
import '@grandvisionhq/iris-ui';

const ActionButtonsContainer = ({ links  })=>{
    const isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    const { getLabel  } = useIntl();
    const labels = React.useMemo(()=>({
            toCart: getLabel('cart.actions.goToCart'),
            toCheckout: getLabel('cart.actions.goToCheckout')
        })
    , [
        getLabel
    ]);
    const [buttonsRef, buttonsInview] = useInView();
    const showStickyButtons = isSmallScreen && !buttonsInview;
    return /*#__PURE__*/ React.createElement(ActionButtons, {
        buttonsRef: buttonsRef,
        isSmallScreen: isSmallScreen,
        labels: labels,
        links: links,
        shouldShowStickyButtons: showStickyButtons
    });
};

export { ActionButtonsContainer };
//# sourceMappingURL=ActionButtonsContainer.js.map
